import React from 'react';
import Card from '../JS/Card';
import '../Styles/MetricCard.css';

const MetricCard = ({icon, title, description}) => {
  return (
    <div className="metric-card-container">
      <Card icon={icon} title={title} description={description}/>
    </div>
  );
};

export default MetricCard;